import { Component, OnInit } from '@angular/core';
import { EquipoService } from '../../services/equipo.service';
import { TEAM } from '../../interfaces/team.interface';

import { equipoJson } from './equipo.json';

import { switchMap } from 'rxjs';

@Component({
  selector: 'app-equipo',
  templateUrl: './equipo.component.html',
  styleUrls: ['./equipo.component.css']
})
export class EquipoComponent implements OnInit {

  isLoaded: boolean = false;
  titleTxt: string = ""
  teamMembers: any;

  isPosition: boolean = false;

  careersStatic: any;

  ordererTeamMembers: any[] = [];

  constructor(private equipoService: EquipoService) { }

  ngOnInit(): void {
    this.equipoService.getTeamStatic().pipe(
      switchMap((resp) => {
        this.titleTxt = resp.data.titleTxt;
        return this.equipoService.getTeamMembersItems();
      }),
      switchMap((teamMembersData) => {
        this.teamMembers = teamMembersData.data.teammates.rows;
        // Sort by id
        this.ordererTeamMembers = this.teamMembers.sort((a, b) => new Date(a.id!).getTime() - new Date(b.id!).getTime());

        // Calcula el número de imágenes a añadir basado en el número de miembros y el número de columnas (asumiendo 4 columnas)
        const numberOfColumns = 4;
        let placeholdersToAdd = numberOfColumns - (this.ordererTeamMembers.length % numberOfColumns);
        placeholdersToAdd = placeholdersToAdd % numberOfColumns; // Asegura que no se añadan 4 si ya es un múltiple de 4

        // Imágenes de marcadores de posición
        const imagePlaceholders = [
          {
            id: 9997,
            imgBigUrl: "assets/img/equipo/img_ofi_1.jpg",
            name: "",
            position: "",
            linkedinUrl: "",
          },
          {
            id: 9998,
            imgBigUrl: "assets/img/equipo/img_ofi_2.jpg",
            name: "",
            position: "",
            linkedinUrl: "",
          },
          {
            id: 9999,
            imgBigUrl: "assets/img/equipo/img_ofi_3.jpg",
            name: "",
            position: "",
            linkedinUrl: "",
          }
        ];

        // Añade las imágenes necesarias desde el final hacia atrás
        if (placeholdersToAdd > 0) {
          for (let i = 0; i < placeholdersToAdd; i++) {
            const index = imagePlaceholders.length - placeholdersToAdd + i;
            this.ordererTeamMembers.push(imagePlaceholders[index]);
          }
        }

        return this.equipoService.getCareersStatic();
      })



    )
      .subscribe({
        next: (careersData) => {
          this.careersStatic = careersData.data;
          if (this.careersStatic.jobs.length > 0) {
            this.isPosition = this.careersStatic.jobs.some(job => job.active);
          }
          this.isLoaded = true;
        },
        error: (err) => {
          // Manejar el error aquí
        }
      });
  }

}
